import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1066bf42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex flex-row pt-5" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-2xl font-bold text-infoColor" }, "資料確認", -1))
const _hoisted_4 = { class: "justify-center pl-10" }
const _hoisted_5 = { class: "flex flex-col border-l-2" }
const _hoisted_6 = { class: "flex flex-row pt-2 items-center text-base font-black" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pl-5 w-36" }, " 會議名稱 ", -1))
const _hoisted_8 = { class: "font-black text-infoColor w-4/5" }
const _hoisted_9 = { class: "flex flex-row pt-2 items-center text-base font-black" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pl-5 w-36" }, " 會議內容 ", -1))
const _hoisted_11 = { class: "font-black text-infoColor w-4/5" }
const _hoisted_12 = { class: "flex flex-row pt-2 items-center text-base font-black" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pl-5 w-36" }, " 回覆截止日期 ", -1))
const _hoisted_14 = { class: "font-black text-infoColor w-4/5" }
const _hoisted_15 = { class: "flex flex-row pt-2 items-center text-base font-black" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pl-5 w-36" }, " 受邀人員 ", -1))
const _hoisted_17 = { class: "font-black text-infoColor w-4/5" }
const _hoisted_18 = { class: "flex flex-row pt-2 items-center text-base font-black" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pl-5 w-36" }, " 時間選項 ", -1))
const _hoisted_20 = { class: "pr-2 text-infoColor" }
const _hoisted_21 = { class: "px-2 py-1 rounded bg-gray-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_scrollbar = _resolveComponent("n-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_scrollbar, { style: {"max-height":"500px"} }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.inviteInfo.EventName), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.inviteInfo.EventContext), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.dayjs( _ctx.inviteInfo.ReplayDealine).format('YYYY/MM/DD (ddd)')), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.optionMember?.map((a) => a).join('、')), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_n_space, {
                  vertical: "",
                  class: "text-sm"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inviteDate, (col, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.dayjs( col.Date).format('YYYY/MM/DD (ddd)')), 1),
                        _createVNode(_component_n_space, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.Time, (coltime, indextime) => {
                              return (_openBlock(), _createElementBlock("div", { key: indextime }, [
                                _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.dayjs( coltime.StartTime).format('HH:mm')) + " - " + _toDisplayString(_ctx.dayjs( coltime.EndTime).format('HH:mm')), 1)
                              ]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}